declare let $load: (url: string) => Promise<void>;

/**
 * 是否顶层路由一致
 * @param last
 * @param next
 * @returns
 */
export function isSameDomain(last: string, next: string) {
  if (!last || !next) return false;
  return last.split('/')[0] === next.split('/')[0];
}

/**
 * 是否是顶层路由
 * @param route
 */
export function isTopPage(route: string) {
  if (route.startsWith('/')) {
    route = route.substring(1);
  }
  return route.indexOf('/') === -1;
}

function hasSubArray(master: string[], sub: string[]) {
  return !master.some((val) => sub.indexOf(val) === -1);
}

export function isSubRoute(parent: string, sub: String) {
  const parents = parent.split('/');
  const subs = sub.split('/');
  return hasSubArray(parents, subs);
}

/**
 * 获取顶层路由
 * @param route
 * @returns
 */
export function getTopRoute(route: string) {
  if (route.startsWith('/')) {
    route = route.substring(1);
  }
  return route.split('/')[0];
}

/**
 * 获取父页面路由
 * @param route
 * @returns
 */
export function getParentRoute(route: string) {
  if (route.startsWith('/')) {
    route = route.substring(1);
  }
  const routes = route.split('/');
  routes.pop();
  return routes.join('/');
}

/**
 * 获取资源
 * @param pageKey
 * @returns
 */
export function loadBuiltFile(path: string) {
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  return $load(path);
}

/**
 * 获取页面资源
 * @param pageCode
 * @returns
 */
export function loadPage(pageCode: string) {
  return loadBuiltFile(`dist/pages/${pageCode}.mjs`);
}
